const JSON_START_CHARS = new Set(['{', '[', '"', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'f', 'n']);

export function parse_json_string(value, fallback = {}) {
  return should_parse_json(value) ? JSON.parse(value) : fallback;
}

function should_parse_json(value = '') {
  return JSON_START_CHARS.has(String(value).trim().charAt(0));
}

export function parse_response_data(response) {
  const raw_data = response?.data ?? response ?? {};
  if (typeof raw_data !== 'string') return raw_data;
  const parsed = parse_json_string(raw_data);
  return parse_nested(parsed);
}

function parse_nested(value) {
  return typeof value === 'string' ? parse_json_string(value) : value;
}

export function to_array(value) {
  return Array.isArray(value) ? value : [];
}

export function to_number(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function normalize_text(value) {
  return String(value || '').trim();
}

export function normalize_key(value) {
  return normalize_text(value).toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export function first_value(values = []) {
  return values.find((value) => value !== undefined && value !== null && value !== '');
}

export function first_count(values = []) {
  for (const value of values) {
    const count = Number(value);
    if (Number.isFinite(count) && count >= 0) return count;
  }
  return 0;
}

export function normalize_entity_type_page(parsed, fallback_page) {
  return {
    items: to_array(value_or(parsed?.data, parsed)).filter((item) => to_number(item?.id)),
    page: Number(value_or(parsed?.page, fallback_page)),
    total_pages: Number(value_or(parsed?.total_pages, 0)),
    count: Number(value_or(parsed?.count, 0))
  };
}

function value_or(value, fallback) {
  return value || fallback;
}
